"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * tlCurrencyInput
 */
ngModule.directive("tlCurrencyInput", function ($interpolate) {
  var DEFAULT_SYMBOL = "€"; // TODO : add service to register default currency ( wire to account currency )
  return {
    restrict: "E",
    replace: true,
    scope: true,
    template: '' + '<div tl-input-wrapper>' + '   <input input-type-number/>' + '   <i class="input-icon currency-icon"></i> ' + '</div>',
    priority: 1200,
    // need to be higher than ngModel or any other transcluding directive
    compile: function compile($el, $attrs) {
      var currencyWatch;

      // The "dual compilating plus terminal" directive combo seems to make angular attribute interpolation break...
      // So we manually handles the currency interpolation & watch.
      if ($attrs.currency) {
        currencyWatch = $interpolate($attrs.currency);
        $attrs.$set("currency", null);
      }
      if ($attrs.allowNegative) {
        $el.find('input').attr('allow-negative', 'true');
      }
      return function postLink($scope, $el, $attrs) {
        $el.addClass("tl-currency-input-wrapper");
        var currencyIcon = $el.find(".currency-icon");
        if (currencyWatch != null) {
          $scope.$watch(currencyWatch, function (currencyValue) {
            var currencySymbol = currencyValue || DEFAULT_SYMBOL;
            currencyIcon.text(currencySymbol);
            if (currencySymbol.length > 1) {
              $el.addClass("long-symbol");
            } else {
              $el.removeClass("long-symbol");
            }
          });
        } else {
          currencyIcon.text(DEFAULT_SYMBOL);
        }
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/inputs/tl-currency-input.js
// module id = 2970
// module chunks = 13